import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../colors-v2';
import { BaseQuotePluginProps, ELEMENT_QUOTE_AUTHOR_CLASSNAME } from '../QuotePlugin.types';

const PLACE_HOLDER_WIDTH = 160;

const Main = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  color: ${colorsV2.black100};

  .text {
    white-space: pre-wrap;
    word-break: break-word;
    display: inline;
  }

  &.empty-text {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;

    .text {
      min-width: ${PLACE_HOLDER_WIDTH}px;
    }
  }

  &:before {
    content: '-';
    color: ${colorsV2.black100};
    display: inline;
  }

  .minus-symbol {
    color: ${colorsV2.black100};
    display: inline;
  }

  .placeholder {
    margin-left: -${PLACE_HOLDER_WIDTH}px;
    pointer-events: none;
    display: inline;
    color: ${colorsV2.gray60};
  }
`;

interface QuoteElementAuthorProps extends BaseQuotePluginProps {}

export const QuoteElementAuthorEditable = (props: QuoteElementAuthorProps) => {
  const { element, attributes, children } = props;
  const text = (element?.children || [])
    .map((item) => item.text)
    .filter(Boolean)
    .join('');

  const isEmptyText = text.length === 0;

  return (
    <Main
      {...attributes}
      className={cl(ELEMENT_QUOTE_AUTHOR_CLASSNAME, { 'empty-text': isEmptyText })}
    >
      <div className="text">{children}</div>
      {isEmptyText && (
        <div contentEditable={false} className="placeholder">
          Please Text Author
        </div>
      )}
    </Main>
  );
};

const TextContainer = styled.p`
  white-space: pre-wrap;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;

export const QuoteElementAuthorReadOnly = (props: QuoteElementAuthorProps) => {
  const { element, attributes, children } = props;
  const text = (element?.children || [])
    .map((item) => item.text)
    .filter(Boolean)
    .join('')
    .trim();

  const isEmptyText = text.length === 0;

  return isEmptyText ? null : <TextContainer {...attributes}>{children}</TextContainer>;
};
